import type {TranspositionResult} from '@/generated';

/**
 * Signatur für die oldValue-Stabilität (VUE_RULES Regel 2, via `stableBySignature`): erfasst alle
 * anzeige-relevanten Felder. Ein reiner Längenvergleich lieferte bei gleich langer, aber inhaltlich
 * anderer Liste (z. B. nach Transpose) die veraltete Referenz zurück.
 */
export function suggestionSignature(items: TranspositionResult[]): string {
    return items
        .map((s) => `${s.target_key}|${s.semitones}|${s.analysis.percentage}|${s.analysis.unmappable_count}|${s.mode_change ?? ''}`)
        .join(';');
}

/**
 * Beste Spielbarkeit zuerst (Gleichstand: weniger unspielbare Noten zuerst) – Element [0] ist der
 * automatisch vorbelegte Vorschlag. Mutiert die Eingabe NICHT und enthält bewusst kein `.reverse()`:
 * das frühere `oldValue.reverse()` im computed mutierte die gecachte Referenz in-place und flippte
 * die angezeigte Reihenfolge bei jedem Recompute.
 */
export function rankSuggestions(items: readonly TranspositionResult[]): TranspositionResult[] {
    return [...items].sort((left, right) => {
        // const percentageDelta = (right.analysis.percentage ?? 0) - (left.analysis.percentage ?? 0);
        // if (percentageDelta !== 0) return percentageDelta;
        return (left.analysis.unmappable_occurrences_count ?? 0) - (right.analysis.unmappable_occurrences_count ?? 0);
    });
}
